import z from 'zod';
import { t } from 'i18next';

const AddUserSchema = z.object({
    username: z.string(),
    name: z.string(),
    password: z.string().min(5),
    repeatPassword: z.string().min(5),
    group: z.number(),
    templateUser: z.number().optional(),
})
    .refine((data) => data.password === data.repeatPassword, {
        error: () => t('PasswordDoesNotMatch'),
        path: ['repeatPassword'],
    });

type AddUserModel = z.infer<typeof AddUserSchema>;
type AddUserModelErrors = z.ZodFlattenedError<AddUserModel>['fieldErrors'];

const safeParse = (data: AddUserModel) => {
    const parseResult = AddUserSchema.safeParse(data);
    if (!parseResult.success) {
        return {
            errors: z.flattenError(parseResult.error).fieldErrors,
        };
    }
    return { ok: true };
};

export {
    type AddUserModel,
    type AddUserModelErrors,
    safeParse,
};
